import React, { useEffect, useState } from 'react';
import { UserIcon } from 'lucide-react';
export const FloatingSocialProof = () => {
  const [notification, setNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const notifications = ['Ravi from Chennai just ordered Sleep Restore Strips', 'Anita from Bangalore is sleeping better with Sleep Restore', 'Vikram from Delhi switched from pills to Sleep Restore Strips', 'Neha from Mumbai just reordered Sleep Restore Strips', 'Suresh from Hyderabad loves the mint flavor of Sleep Restore'];
  useEffect(() => {
    // Show notifications periodically
    const intervalId = setInterval(() => {
      if (!isVisible) {
        const randomNotification = notifications[Math.floor(Math.random() * notifications.length)];
        setNotification(randomNotification);
        setIsVisible(true);
        // Hide after 5 seconds
        setTimeout(() => {
          setIsVisible(false);
        }, 5000);
      }
    }, 15000);
    // Show first notification after 5 seconds
    const timeoutId = setTimeout(() => {
      const randomNotification = notifications[Math.floor(Math.random() * notifications.length)];
      setNotification(randomNotification);
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }, 5000);
    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-md p-3 max-w-xs animate-slideInUp" data-id="element-244">
      <div className="flex items-center" data-id="element-245">
        <div className="bg-indigo-100 rounded-full h-10 w-10 flex items-center justify-center mr-3" data-id="element-246">
          <UserIcon className="h-5 w-5 text-indigo-600" data-id="element-247" />
        </div>
        <p className="text-sm text-gray-800" data-id="element-248">{notification}</p>
      </div>
    </div>;
};